import React from 'react'
import { GridCell, GridRow } from '@mobi/component-library/Legacy/Grid'
import { ActiveCampaignsComponent } from './ActiveCampaign'
import { MysteryBonusButtonStyled } from './Campaigns.styles'

type BonusCashCampaignProps = {
  defaultValue: boolean
  toggleCampaign: (isApplied: boolean) => void
}

export const BonusCashCampaign = ({ defaultValue, toggleCampaign }: BonusCashCampaignProps) => {
  const [useBonusCash, setUseBonusCash] = React.useState(defaultValue)

  const handleBonusHandler = () => {
    const newState = !useBonusCash
    setUseBonusCash(newState)
    toggleCampaign(newState)
  }

  return (
    <GridRow padding='0.5rem 0.5rem 0 0.5rem'>
      <GridCell>
        {!useBonusCash ? (
          <MysteryBonusButtonStyled onClick={handleBonusHandler}>
            Use My Bonus
          </MysteryBonusButtonStyled>
        ) : (
          <ActiveCampaignsComponent handleRemoveBonusCashButtonClick={handleBonusHandler} />
        )}
      </GridCell>
    </GridRow>
  )
}
